import { render, staticRenderFns } from "./GoodsLsxfdetail.vue?vue&type=template&id=dcce3d2c&"
import script from "./GoodsLsxfdetail.vue?vue&type=script&lang=js&"
export * from "./GoodsLsxfdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports